import * as React from 'react';

const IsContract = () => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3ZM2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3Zm7.595 3.617a2.106 2.106 0 0 0-2.972-.007l-.006.007a2.104 2.104 0 0 0 0 2.978l.005.005a2.106 2.106 0 0 0 2.973-.005 1 1 0 1 1 1.414 1.415 4.106 4.106 0 1 1 0-5.807 1 1 0 0 1-1.414 1.414Z"
      fill="#BFC4CE"
    />
  </svg>
);

export default IsContract;
